import { render } from "./card-dialog.vue?vue&type=template&id=2dba42dc&scoped=true&ts=true"
import script from "./card-dialog.vue?vue&type=script&lang=ts"
export * from "./card-dialog.vue?vue&type=script&lang=ts"

import "./card-dialog.vue?vue&type=style&index=0&id=2dba42dc&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dba42dc"]])

export default __exports__